import { createContext, useContext } from 'react';

/**
 * @type {React.Context<{
 *  rootPath: string,
 *  rootAccessPath: string[],
 * }>}
 */
export const RouterContext = createContext();

export function useRouter() {
  const context = useContext(RouterContext);
  if (!context) {
    throw new Error('useRouter must be used within a RouterProvider');
  }
  return context;
}
